// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/back-15.svg';

export const Back15 = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
